var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var IconClose = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, props = __rest(_a, ["size", "className"]);
    return (_jsx("span", __assign({ className: "mex-icon mex-icon--".concat(size, " ").concat(className) }, props, { children: _jsxs("svg", __assign({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("g", __assign({ clipPath: "url(#clip0_1_89)" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.6914 6.30851C25.2814 5.89846 24.6165 5.89846 24.2065 6.30851L15.999 14.516L7.79149 6.30855C7.38143 5.8985 6.71661 5.8985 6.30656 6.30855C5.89651 6.7186 5.89651 7.38342 6.30656 7.79347L14.5141 16.001L6.30662 24.2084C5.89657 24.6184 5.89657 25.2833 6.30662 25.6933C6.71667 26.1034 7.3815 26.1034 7.79155 25.6933L15.999 17.4859L24.2064 25.6933C24.6165 26.1034 25.2813 26.1034 25.6914 25.6933C26.1014 25.2833 26.1014 24.6185 25.6914 24.2084L17.4839 16.001L25.6914 7.79344C26.1015 7.38339 26.1015 6.71856 25.6914 6.30851Z" }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_1_89" }, { children: _jsx("rect", { width: "32", height: "32", fill: "white" }) })) })] })) })));
};
export default IconClose;
